import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { URLS } from 'config/urls';

import SetPassword from 'pages/SetPassword';
import NotFound from 'pages/NotFound';
import Login from 'pages/Login';

const ENABLE_FLIGHTS_FEATURE = import.meta.env.VITE_ENABLE_FLIGHTS_FEATURE;

let paths = [
  {
    path: URLS.SET_PASSWORD,
    element: <SetPassword />,
  },
  {
    path: '/not-found', // Catch-all route for undefined paths
    element: <NotFound />,
  },
  {
    path: '*', // Catch-all route for undefined paths
    element: <NotFound />,
  },
];

if (ENABLE_FLIGHTS_FEATURE === 'true') {
  paths = [
    ...paths,
    {
      path: URLS.LOGIN,
      element: <Login />,
    },
  ];
}

const router = createBrowserRouter(paths);

const Routes = () => <RouterProvider router={router} />;

export default Routes;
